"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const menuItem_component_1 = require("./menuItem.component");
const measure_component_1 = require("../measure/measure.component");
const chevronDown_component_1 = require("../support/components/chevronDown.component");
const MAIN_ITEM_KEY = 'Main Item';
const DIVIDER_ELEMENT_KEY = 'Divider';
class SubMenuComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            subItemsVisible: false,
            subItemsHeight: 0,
        };
        this.subItemsAnimation = new react_native_1.Animated.Value(0);
        this.iconAnimation = new react_native_1.Animated.Value(0);
        this.subItemsExpandAnimate = (toValue) => {
            react_native_1.Animated.spring(this.subItemsAnimation, {
                toValue: toValue,
            }).start();
        };
        this.animateIcon = (toValue) => {
            react_native_1.Animated.timing(this.iconAnimation, {
                toValue: toValue,
                duration: 200,
            }).start();
        };
        this.onMainItemPress = () => {
            const subItemsVisible = !this.state.subItemsVisible;
            this.setState({ subItemsVisible });
        };
        this.onSubItemPress = (index, event) => {
            if (this.props.onSelect) {
                this.props.onSelect(index, event);
            }
        };
        this.getComponentStyles = (style) => {
            return {
                subContainer: {
                    paddingHorizontal: style.subItemsPaddingHorizontal,
                },
            };
        };
        this.onSubMenuMeasure = (frame) => {
            this.setState({ subItemsHeight: frame.size.height });
        };
        this.getIsSelected = (item) => {
            const { selectedIndex } = this.props;
            return selectedIndex === item.menuIndex;
        };
        this.isMainItemDividerExist = () => {
            const { divider } = this.props;
            const { subItemsVisible } = this.state;
            return subItemsVisible && divider !== null;
        };
        this.isSubItemDividerExist = (item, index) => {
            const { divider } = this.props;
            return (index !== item.subItems.length - 1) && (divider !== null);
        };
        this.renderDivider = () => {
            const { divider } = this.props;
            return divider && react_1.default.cloneElement(divider, {
                key: DIVIDER_ELEMENT_KEY,
            });
        };
        this.renderMainItemAccessory = (style) => {
            const rotateInterpolate = this.iconAnimation.interpolate({
                inputRange: [-180, 0],
                outputRange: ['-180deg', '0deg'],
            });
            const animatedStyle = { transform: [{ rotate: rotateInterpolate }] };
            return (react_1.default.createElement(react_native_1.Animated.View, { style: animatedStyle },
                react_1.default.createElement(chevronDown_component_1.ChevronDown, Object.assign({}, style))));
        };
        this.renderMenuItem = (item, isMainItem, index) => {
            const onPressHandler = isMainItem ? this.onMainItemPress : this.onSubItemPress;
            const mainMenuItemAccessory = isMainItem ? this.renderMainItemAccessory : null;
            return (react_1.default.createElement(menuItem_component_1.MenuItem, Object.assign({}, item, { key: index, accessory: mainMenuItemAccessory, onPress: onPressHandler })));
        };
        this.renderSubItemsInvisible = (subItems) => {
            return (react_1.default.createElement(measure_component_1.MeasureElement, { onMeasure: this.onSubMenuMeasure },
                react_1.default.createElement(react_native_1.View, { pointerEvents: 'none', style: styles.invisibleMenu }, subItems)));
        };
        this.renderSubItems = () => {
            const { item, themedStyle, divider } = this.props;
            return item.subItems.map((sub, index) => {
                const { subContainer } = this.getComponentStyles(themedStyle);
                const isSelected = this.getIsSelected(sub);
                const element = react_1.default.cloneElement(this.renderMenuItem(sub, false, index), {
                    style: subContainer,
                    selected: isSelected,
                });
                const dividerElement = this.isSubItemDividerExist(item, index) ?
                    this.renderDivider() : null;
                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    element,
                    dividerElement));
            });
        };
        this.renderComponentChildren = () => {
            const { item } = this.props;
            return [
                this.renderMenuItem(item, true, MAIN_ITEM_KEY),
                this.renderSubItems(),
                this.isMainItemDividerExist() ? this.renderDivider() : null,
            ];
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.subItemsVisible !== this.state.subItemsVisible) {
            if (this.state.subItemsVisible) {
                this.subItemsExpandAnimate(this.state.subItemsHeight);
                this.animateIcon(-180);
            }
            else {
                this.subItemsExpandAnimate(0);
                this.animateIcon(0);
            }
        }
    }
    render() {
        const { subItemsVisible } = this.state;
        const [mainItem, subItems, divider] = this.renderComponentChildren();
        const invisibleSubs = this.renderSubItemsInvisible(subItems);
        const animatedStyle = { height: this.subItemsAnimation };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            mainItem,
            divider,
            react_1.default.createElement(react_native_1.Animated.View, { style: animatedStyle }, subItemsVisible && subItems),
            invisibleSubs));
    }
}
SubMenuComponent.styledComponentName = 'SubMenu';
const styles = react_native_1.StyleSheet.create({
    invisibleMenu: {
        opacity: 0,
        position: 'absolute',
    },
});
exports.SubMenu = theme_1.styled(SubMenuComponent);
//# sourceMappingURL=subMenu.component.js.map